import './footer.component.scss';

export default {
  template: require('./footer.component.html'),
  controller: function ($auth) {
    'ngInject';

    const self = this;

    self.currentYear = new Date().getFullYear();

    self.isVisible = () => {
      return !$auth.isLogin();
    };

  }
};
